import { isNil } from 'lodash';
// Import Components
import { Helpers } from 'services';
// Import Constants
import { l } from 'constants/common';
// Import Enums
import { FormatNumberActionEnum } from 'enums';

const { formatNumber } = Helpers;

export const DataTableColumnsConfigs = (t, userCurrencyId) => {
    return {
        columns: [
            {
                text: t(l.Currency),
                dataKey: 'CurrencyId',
                sortable: true,
            },
            {
                text: t(l.Count),
                dataKey: 'Count',
                sortable: true,
                colRenderer: (count) =>
                    formatNumber(count, {
                        type: FormatNumberActionEnum.DecimalPrecision,
                        precision: 0,
                    }),
            },
            {
                text: t(l.Amount),
                dataKey: 'Amount',
                sortable: true,
                colRenderer: (amount) =>
                    formatNumber(amount, {
                        type: FormatNumberActionEnum.DecimalPrecision,
                        precision: 2,
                    }),
            },
            {
                text: t(l.AmountInCurrency, {
                    currencyId: userCurrencyId,
                }),
                dataKey: 'AmountInUserCurrency',
                sortable: true,
                colRenderer: (amount) =>
                    isNil(amount)
                        ? t(l.NA)
                        : formatNumber(amount, {
                              type: FormatNumberActionEnum.DecimalPrecision,
                              precision: 2,
                          }),
            },
        ],
    };
};
